import { create } from "zustand";

const vehicleMasterData = create((set) => ({
  data: [],

  addItem: (item) =>
    set({
      data: item, // overwrite previous data
    }),

  clearData: () => set({ data: [] }),
}));

export default vehicleMasterData;

export const vehicleAction = create((set) => ({
  value: "",

  addItem: (item) =>
    set({
      value: item, // overwrite previous value
    }),

  clearData: () => set({ value: "" }),
}));